import { cn } from "../../utils";

type LoaderProps = {
  className?: string;
  size?: "sm" | "md" | "lg" | string;
};

export const Loader = ({ className = "", size }: LoaderProps) => {
  const baseClassName =
    "animate-spin rounded-full border-2 border-border-accent border-t-transparent";
  const sizeClassName =
    size === "sm" ? "h-3 w-3" : size === "lg" ? "h-8 w-8" : "h-6 w-6";

  return (
    <div className={cn("flex items-center justify-center py-2", className)}>
      <span className={cn(sizeClassName, baseClassName)} />
    </div>
  );
};

export default Loader;
